import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function referentieReducer(state = initialState.referentie, action) {
	switch (action.type) {
		case types.REFERENCES_LOADED: {
			let referenceData = {};

			Object.keys(action.body).forEach(key => {
				referenceData[key] = Object.keys(action.body[key]).map(k => { return { value: k, label: action.body[key][k] }; });
			});

			return mergeDeep({}, referenceData);
		}

		default:
			return state;
	}
}